import React from 'react'

const Name = () => (
  <>
    <h1 className='heading main-name'>Canonico Fine Art</h1>
  </>
)

export default Name